import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import ModuloSeguridad from "@/components/seguridad/store.js";

const vuexLocal = new VuexPersistence({
  key: "cartones-del-pacifico",
  storage: window.localStorage
});

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    seguridad: ModuloSeguridad
  },
  getters: {
    appName: () => process.env.APP_NAME
  }
});

export default store;
